export default "__VITE_ASSET__BShDQkQ5__"